import { type CSSProperties, type FC, useContext } from "react";
import { createStyleFromPadding } from "../../../PaddingInput";
import { createBorderStyles } from "../../BorderSettingsDialog";
import { DragDropRenderContext } from "../../DragDropRenderer";
import { type ColumnComponentType } from "../../DragDropTypes";

export const ColumnComponent: FC<Omit<ColumnComponentType, "type">> = ({
    value,
    style,
}) => {
    const { items } = useContext(DragDropRenderContext);

    const { border, padding } = style;

    const wrapperStyle: CSSProperties = {
        width : "100%",
        height: "100%",
        ...createStyleFromPadding(padding),
    };

    const tableStyle: CSSProperties = {
        width      : "100%",
        height     : "100%",
        tableLayout: "fixed",
        ...createBorderStyles(border),
    };

    const colStyle: CSSProperties = {
        position     : "relative",
        border       : "none",
        verticalAlign: "top",
        padding      : "0",
        overflow     : "hidden",
        height       : "100%",
    };

    return (
        <div style={wrapperStyle}>
            <table style={tableStyle}>
                <tbody>
                    <tr>
                        {value.map((column, index) => {
                            return (
                                <td
                                    key={index}
                                    style={{
                                        ...colStyle,
                                        width: (column.width * 100) + "%",
                                    }}
                                >
                                    {column.components.map((component, index) => {
                                        const definition = items[component.type];

                                        if(!definition) {
                                            return null;
                                        }

                                        const Component = definition.component;

                                        return (
                                            <Component
                                                key={index}
                                                value={component.value}
                                                style={component.style}
                                            />
                                        );
                                    })}
                                </td>
                            );
                        })}
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
